var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"logoMoudle",staticClass:"brt-map-LogoMoudle"},[_c('a',[_c('img',{attrs:{"src":_vm.LOGO}})])])}
var staticRenderFns = []

export { render, staticRenderFns }